module.exports = __webpack_public_path__ + "media/gili/lone_boat-4bf88d44.jpg";